const LOGOS = [
  { src: "/brand-logos/maruti-suzuki.png", alt: "Maruti Suzuki" },
  { src: "/brand-logos/tata-motors.png", alt: "Tata Motors" },
  { src: "/brand-logos/kia.png", alt: "Kia" },
  { src: "/brand-logos/renault.png", alt: "Renault" },
  { src: "/brand-logos/gomechanic.png", alt: "GoMechanic" },
  { src: "/brand-logos/cardekho.png", alt: "CarDekho" },
];

export const TrustedMarquee = () => {
  // Duplicate the set so the -50% translate loops seamlessly and endlessly.
  const loop = [...LOGOS, ...LOGOS];

  return (
    <section
      className="border-b border-[color:var(--acx-border)] py-10 sm:py-12"
      data-testid="trusted-marquee"
      aria-label="Trusted by India's best automotive companies"
    >
      <h2 className="px-4 text-center text-[12px] font-medium uppercase tracking-[0.2em] text-white/55 sm:text-[13px]">
        Trusted by India&rsquo;s best automotive companies
      </h2>

      <div className="acx-logo-marquee mt-8 sm:mt-9">
        <div className="acx-logo-marquee__track">
          {loop.map((logo, i) => (
            <div
              className="acx-logo-marquee__item"
              key={`${logo.alt}-${i}`}
              data-testid={i < LOGOS.length ? `trusted-logo-${logo.alt.toLowerCase().replace(/\s+/g, "-")}` : undefined}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                className="acx-logo-marquee__logo"
                draggable="false"
                loading="lazy"
                aria-hidden={i >= LOGOS.length ? "true" : undefined}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedMarquee;
